import React, { useState, useEffect, useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { getLabel } from '@catalogo/ui-americanas-desktop-product-review/src/helpers';
import { useHandleSortBy } from '@catalogo/ui-americanas-desktop-product-review/src/hooks';
import { ModalSheet } from '../ModalSheet';
import { Wrapper, SortIcon, Label, SortTitle, Select, Option, Title } from './Styled';

const SelectSort = (props: any) => {
  const { sorts, dispatchMetrics } = props;
  const { queryParam } = useContext<any>(context);
  const { handleSortBy } = useHandleSortBy();
  const [defaultSelected] = sorts;
  const [label, setLabel] = useState(defaultSelected.label);
  const [visible, setVisible] = useState(false);
  const checkedLabel = getLabel(queryParam.sortBy);
  const exitFunc = () => setVisible(false);
  const toggleModal = React.useCallback(() => setVisible(!visible), [visible]);

  const onChange = ({ target }: { target: { name: string } }) => {
    const { name } = target;
    const { value } = sorts.find((arr: { label: string }) => arr.label === name);
    handleSortBy({ sortBy: value });

    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'avaliacoes-ordenacao',
      label: target.name,
    });

    setVisible(false);
  };

  useEffect(() => {
    setLabel(getLabel(queryParam.sortBy));
  }, [queryParam]);

  useEffect(() => {
    const handleAfterClick = (e: any) => {
      const clickOutside = e.target.className.includes('src__Wrapper');
      if (clickOutside) {
        toggleModal();
      }
    };

    if (visible) {
      document.addEventListener('click', handleAfterClick);
    }

    return () => {
      document.removeEventListener('click', handleAfterClick);
    };
  }, [visible, toggleModal]);

  const renderCheckbox = sorts?.map((sort: any) => (
    <Option key={sort.value}>
      <input type="radio" id={sort.label} name={sort.label} onChange={onChange} checked={label === sort.label} />
      <label htmlFor={sort.label}>{sort.label}</label>
    </Option>
  ));

  return (
    <>
      <Wrapper onClick={toggleModal} className="product-review-select-sort-wrapper">
        <SortIcon className="product-review-select-sort-wrapper-icon" />
        <SortTitle className="product-review-select-sort-wrapper-title">ordenar</SortTitle>
        <Label className="product-review-select-sort-wrapper-label">{checkedLabel}</Label>
      </Wrapper>
      <ModalSheet visible={visible} exitFunc={exitFunc}>
        <Title className="product-review-select-sort-modal-sheet-title">ordenar por</Title>
        <Select className="product-review-select-sort-modal-sheet-select">{renderCheckbox}</Select>
      </ModalSheet>
    </>
  );
};

SelectSort.defaultProps = {
  sorts: [
    {
      label: 'mais relevantes',
      value: ['scoreDesc', 'createdAtDesc'],
    },
    {
      label: 'mais recentes',
      value: ['createdAtDesc'],
    },
    {
      label: 'mais antigas',
      value: ['createdAtAsc'],
    },
    {
      label: 'mais positivas',
      value: ['ratingDesc', 'scoreDesc', 'createdAtDesc'],
    },
    {
      label: 'mais negativas',
      value: ['ratingAsc', 'scoreDesc', 'createdAtDesc'],
    },
  ],
};

export default SelectSort;
export { SelectSort };
